export class DocumentRef {

  public getNativeDocument(): Document {
    return document;
  }

}
